import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
    paper: {
        borderRadius: '20px !important',
        borderTopLeftRadius: '0 !important',
        borderTopRightRadius: '0 !important',
        backgroundColor: `${theme.palette.figma.grayscale.tier7} !important`,
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.20) !important',
        borderTop: `1px solid ${theme.palette.figma.grayscale.stroke} !important`,
        transition: 'none !important',
        maxHeight: '300px !important',
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: `${theme.spacing(1.5)} !important`,
        padding: `${theme.spacing(2)} !important`,
        '& > li': {
            minHeight: 'auto !important',
        },
    },
}))
